export default [
  {
    path: '/discounts',
    name: 'discounts',
    component: () =>
      import(/* webpackChunkName: "campaigns" */
        /* webpackMode: "lazy" */
        `./views/CampaignsList.vue`)
  },
  {
    path: '/discounts/:id',
    name: 'single-discount',
    component: () =>
      import(/* webpackChunkName: "campaigns" */
        /* webpackMode: "lazy" */
        `./views/CampaignsSingle.vue`)
  }
]
